import * as Sentry from "@sentry/react";
import { IS_PRODUCTION, SENTRY_DSN, SENTRY_TRACE_TARGETS } from "@/config";

export function init() {
  if (IS_PRODUCTION) {
    Sentry.init({
      dsn: SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: SENTRY_TRACE_TARGETS,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }
}

export function trackError(error: Error) {
  if (IS_PRODUCTION) {
    Sentry.captureException(error);
  } else {
    console.error(error);
  }
}
